const buttonModalEquipService = {
  text: 'agregar sección'
};

export default buttonModalEquipService;
